<template>
  <v-btn
    rounded
    class="language-button sn-btn"
    height="40"
    tabindex="7"
    :data-cy="locale + '-button'"
    :color="translucentButtonColor"
    @click="switchLocale()"
  >
    <v-icon
      left
    >
      sn-icon-earth
    </v-icon>
    {{ locale }}
  </v-btn>
</template>

<script>
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import localeMixin from '../../Onboarding/Shared/localeMixin.js'

export default {
  name: 'LanguageButton',
  mixins: [localeMixin],
  computed: {
    translucentButtonColor () {
      return this.rgbaFromHexAndOpacity(
        this.$vuetify.theme.themes.dark.tertiary,
        0.7
      )
    },
    sac () {
      return this.$route.params.code
    },
    locale () {
      return document.cookie.includes('locale=en') ? 'Español' : 'English'
    }
  },
  methods: {
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import '~/assets/css/snui';

  .language-button {
    text-transform: none;
    color: $sn-white !important;
    position: absolute;
    top: 32px;
    right: 32px;
  }
</style>
